import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SpinnerComponent } from '../components/spinner/spinner.component';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private overlayRef?: DynamicDialogRef;



  //mensaje_error_failure: string ='';
  //mensaje_error_e2: string = '';

  constructor(private dialogService: DialogService) {

  }

  public show(): void {
    if (!this.overlayRef) {
      this.overlayRef = this.dialogService.open(SpinnerComponent, {
        closable: false,
        modal: true,
        duplicate: false,
        showHeader: false,
        styleClass: 'custom-dialog-modal-spinner',
        style: { 'box-shadow': 'none', 'border': 'none', 'width': '150px', 'height': '150px', 'background-color': 'transparent' },
        contentStyle: {
          'background-color': 'transparent'
        }
      });
    }
  }

  public async hide(error?: any): Promise<void> {
    if (this.overlayRef) {
      this.overlayRef.close();
      this.overlayRef.destroy();
      this.overlayRef = undefined;
    }
    if (error) {
      // const traduc = this.translateService.instant('spinner');
      let message = '';
      if (!error.status) {
        message = error.message;
      } else if (error.status >= 400) {
        message = error?.error.message;
      }
      // message = this.nvlMessage(message);
      Swal.fire({
        icon: 'error',
        text: message,
        confirmButtonColor: 'var(--primary-color)',
        confirmButtonText: 'Cerrar',
        allowOutsideClick: false,
      }).then(() => { });
    }
  }

}